import queryString from 'query-string';

import { getCampaignType, campaignId } from 'pages/MyAccount/utils/campaign';
import env from 'pages/MyAccount/utils/env';
import request from './request';

export function getSearchTerms() {
  const type = getCampaignType();
  const queryParams = {
    type,
  };
  if (campaignId) {
    queryParams.campaignId = campaignId;
  }
  const requestUrl = `${
    env.aceApi
  }api/1/campaigns/products/search-terms?${queryString.stringify(queryParams)}`;
  return request(requestUrl);
}

export function getCategories() {
  const type = getCampaignType();
  let requestUrl = `${env.aceApi}api/1/categories?campaignType=${type}`;
  if (campaignId !== null) {
    requestUrl += `&campaignId=${campaignId}`;
  }
  return request(requestUrl);
}

export const getCustomizeLastQuestion = () =>
  request(`${env.customize}/customize/questions/last-question`);

export function getSpecData(id) {
  return request(`${env.erosURL}/${id}.json`);
}
